import React, { memo } from 'react';
import AppLink from '../../../../components/AppLink';
import BrowserLink from '../../../../components/BrowserLink';
import './FeaturedSmCard.scss';

export const FeaturedSmCard = memo(function Card({
  data: { img, url, react_route, title },
  ...props
}) {

  const wrapperClasses = 'FeaturedSmCard';
  const content = (
    <div
      onClick={(e) => {
        // actid=2.2
        window.analytics?.track("banner:click", {
          "title": img,
          "url": react_route ? react_route : url
        });
    }}>
      <div className="FeaturedSmCard__image-block">
        <img src={img} alt="" />
      </div>
      {title && (
        <span className="FeaturedSmCard__title">{title}</span>
      )}
    </div>
  );

  if(react_route) {
    return (
      <AppLink to={react_route} className={wrapperClasses} {...props}>
        {content}
      </AppLink>
    );
  }

  if(url) {
    return (
      <BrowserLink href={url} className={wrapperClasses} {...props}>
        {content}
      </BrowserLink>
    );
  }
});
